<template>
  <span>
    <px-situacao-aprovacao :icon-in-right="iconInRight"
     v-if="!showAsIcon" :situacao="situacaoUser"/>
    <px-situacao-aprovacao-icon :icon-in-right="iconInRight"
     v-if="showAsIcon" :situacao="situacaoUser"/>
  </span>
</template>

<script>
import { situacaoAprovacaoItemUser } from '@/modules/aprovacao-solicitacao/aprovador-solicitacao-utils';
import { mapGetters } from 'vuex';

export default {
  props: {
    itemAprovacao: Object,
    showAsIcon: {
      type: Boolean,
      default: false,
    },
    iconInRight: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('user', ['user']),
    situacaoUser() {
      return situacaoAprovacaoItemUser(this.user, this.itemAprovacao);
    },
  },
};
</script>
